import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  FormFeedback,
  Form,
  Input,
} from "reactstrap";
import Select from "react-select";
import {
  resourcesRoutes,
  resourcesFuelSales,
  getUnitsWithOperators,
  resourcesConfigurationRoute,
  postRouteConfig
} from "../../../helpers/backend_helper";
import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from "../../../components/Fields/NibbleInput";

const formatter = new Intl.NumberFormat('es-MX', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const ConfigModal = ({
  modal,
  setModal,
  salario,
  setSalario,
  descuento,
  setDescuento,
  primaDominical,
  setPrimaDominical,
  completeHandler,
  authUser,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setModal({ ...modal, show: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { 
      salario: salario,
      descuento: descuento,
      primaDominical: primaDominical 
    },
    validationSchema: Yup.object({
      salario: Yup.number().nullable(true).required("Requerido"),
      descuento: Yup.number().nullable(true).required("Requerido"),
      primaDominical: Yup.number().nullable(true).required("Requerido"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      await save(values);
      setLoading(false);
    },
  });

  const save = async (values) => {
    const response = await postRouteConfig({
      15: values.salario,
      16: values.descuento,
      17: values.primaDominical
    })
    
    setSalario(response.filter(e=>e.configuration_id==15)[0].value)
    setDescuento(response.filter(e=>e.configuration_id==16)[0].value)
    setPrimaDominical(response.filter(e=>e.configuration_id==17)[0].value)
    if(completeHandler)
      completeHandler()
  };

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          Establecer Precio de Combustible
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <NibbleInput
                md={12}
                label="Salario diario:"
                fieldName="salario"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={12}
                label="Factor descuento IMSS:"
                fieldName="descuento"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={12}
                label="Prima Dominical:"
                fieldName="primaDominical"
                fieldType="number"
                validation={validation}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cerrar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default ConfigModal;
